<template>
    <div style="margin-bottom:15px;margin-top:15px;">
        <div v-for="model in question.answers" v-bind:key="model.uid">
            <label
                    v-bind:for="question.uid" v-bind:class="{ selected: model.selected }">
            </label>
            <textarea v-model="model.value" class="form-control text-area-input" :placeholder="model.title"
                      v-bind:maxlength="question.config.max_length"
                      :name="question.uid"></textarea>
        </div>
    </div>
</template>

<script>
	export default {
		name: 'text-input',
		props: ['question'],
		data() {
			return {};
		},
		methods: {},
		components: {}
	};
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .10s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
    {
        opacity: 0;
    }
</style>
